<template>
  <div class="p-0-16 p-16-0 bg-FFFFFF ff-regular">
    <div class="lh-60 bb font-50 c-000 ff-semibol mb-16">
      {{ content.title }}
    </div>
    <p class="mb-16 c-006AFE font-32" v-if="showLink" @click="handlerLinkList">
      点击查看更多说明
    </p>
    <div class="font-32 pb-20 c-000 lh-25">
      <div
        v-for="(item, index) in detail"
        :key="index"
        class="lh-24 pb-10"
        v-html="item"
      >
      </div>
    </div>
  </div>
</template>

<script>
import { HELP_DATA } from '@/utils/helpConst'
import mixin from '@/mixin'

import { LEAVE_ROLE } from '@/utils/constUtils'
export default {
  mixins: [mixin],
  props: {
    link: {
      type: [String],
      default: ''
    },
    showLink: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      HELP_DATA: HELP_DATA,
      content: {},
      detail: {},
      role: 0,
      level: {
        1: 'guardian',
        2: 'headmaster',
        3: 'admin'
      }
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    initData() {
      let _detail = HELP_DATA[this.link]
      this.content = _detail
      if (this.curIsAdmin) {
        this.role = LEAVE_ROLE.admin
      } else if (this.curIsCampusHeadmaster) {
        this.role = LEAVE_ROLE.headmaster
      } else if (this.curIsGuardian) {
        this.role = LEAVE_ROLE.guardian
      }
      this.detail = _detail.data[this.level[this.role]]
    },
    handlerLinkList() {
      this.$router.replace({
        path: '/helpIndex'
      })
    }
  }
}
</script>

<style lang="scss">
.help-title {
  line-height: 20px;
  padding: 12px 0;
  border-bottom: 1px solid #ededed;
  span {
    display: inline-block;
    padding-left: 4px;
    border-left: 4px solid #006afe;
    font-family: PingFangSC-Semibold;
    font-size: 18px;
    color: #000;
    letter-spacing: 0;
  }
}
</style>
